import { Field, Formik } from 'formik'
import { find, isEmpty } from 'lodash'
import { useMemo } from 'react'
import { Button, InputForm } from 'uikit'
import { toaster } from 'uikit/Toaster'
import {
  CardContainer,
  Container,
  ContentContainer,
  ContentContainerColumn,
  Form,
  FormSection,
} from 'uikit/layout'
import * as Yup from 'yup'
import { useFetchSettings } from './services/useFetchSettings'
import { useUpdateSettings } from './services/useUpdateSettings'

const formSchema = Yup.object().shape({
  refLinkUseCount: Yup.string().test('reward', 'Заполните поле', (e) => !Number(isNaN(e) || e < 0)),
  refLinkCodeMaxSymbols: Yup.string().test(
    'reward',
    'Заполните поле',
    (e) => !Number(isNaN(e) || e < 0)
  ),
  conversion: Yup.string().test('reward', 'Заполните поле', (e) => !Number(isNaN(e) || e < 0)),
})

export const Settings = () => {
  const { data: dataSettings, isPending: isLoadingFetchSettings } = useFetchSettings()
  const { mutateAsync: updateSettings, isPending: isLoadingUpdate } = useUpdateSettings()

  const data = useMemo(() => {
    if (isEmpty(dataSettings)) {
      return {
        refLinkUseCount: 0,
        refLinkCodeMaxSymbols: 0,
        conversion: 0,
        maxTransfer: 0,
        minTransfer: 0,
      }
    }
    const refLinkUseCount = find(dataSettings, (e) => e.key === 'REF_LINK_USE_COUNT')
    const refLinkCodeMaxSymbols = find(dataSettings, (e) => e.key === 'REF_LINK_CODE_MAX_SYMBOLS')
    const conversion = find(dataSettings, (e) => e.key === 'CONVERSION')
    const maxTransfer = find(dataSettings, (e) => e.key === 'MAX_TRANSFER')
    const minTransfer = find(dataSettings, (e) => e.key === 'MIN_TRANSFER')
    return {
      refLinkUseCount: refLinkUseCount?.value ?? 0,
      refLinkCodeMaxSymbols: refLinkCodeMaxSymbols?.value ?? 0,
      conversion: conversion?.value ?? 0,
      maxTransfer: maxTransfer?.value ?? 0,
      minTransfer: minTransfer?.value ?? 0,
    }
  }, [dataSettings])

  const handleForm = async (values) => {
    try {
      await updateSettings({
        id: 'REF_LINK_USE_COUNT',
        data: {
          key: 'REF_LINK_USE_COUNT',
          value: Number(values?.refLinkUseCount),
        },
      })
      await updateSettings({
        id: 'REF_LINK_CODE_MAX_SYMBOLS',
        data: {
          key: 'REF_LINK_CODE_MAX_SYMBOLS',
          value: Number(values?.refLinkCodeMaxSymbols),
        },
      })
      await updateSettings({
        id: 'CONVERSION',
        data: {
          key: 'CONVERSION',
          value: Number(values?.conversion),
        },
      })
      await updateSettings({
        id: 'MAX_TRANSFER',
        data: {
          key: 'MAX_TRANSFER',
          value: Number(values?.maxTransfer),
        },
      })
      await updateSettings({
        id: 'MIN_TRANSFER',
        data: {
          key: 'MIN_TRANSFER',
          value: Number(values?.minTransfer),
        },
      })
      toaster.create({
        description: 'Настройки успешно обновлены',
        type: 'success',
      })
    } catch (e) {
      toaster.create({
        description: 'Неудалось сохранить настройки',
        type: 'error',
      })
    }
  }

  const isLoading = isLoadingFetchSettings || isLoadingUpdate

  return (
    <Container>
      <CardContainer indentTop={120} isHideBack>
        <ContentContainer>
          <ContentContainerColumn>
            <Formik
              initialValues={{
                refLinkUseCount: String(data?.refLinkUseCount),
                refLinkCodeMaxSymbols: String(data?.refLinkCodeMaxSymbols),
                conversion: String(data?.conversion),
                maxTransfer: String(data?.maxTransfer),
                minTransfer: String(data?.minTransfer),
              }}
              enableReinitialize
              onSubmit={handleForm}
              validationSchema={formSchema}
              validateOnMount
            >
              {(props) => (
                <Form
                  onSubmit={props.handleSubmit}
                  footer={
                    <Button
                      type="submit"
                      colorPalette="orange"
                      loading={isLoading}
                      disabled={!props.isValid}
                    >
                      Обновить
                    </Button>
                  }
                >
                  <FormSection>
                    <Field
                      name="refLinkUseCount"
                      component={InputForm}
                      label="Максимальное число использования ссылки"
                      disabled={isLoading}
                    />
                    <Field
                      name="refLinkCodeMaxSymbols"
                      component={InputForm}
                      label="Количество символов в ссылке"
                      disabled={isLoading}
                    />
                    <Field
                      name="conversion"
                      component={InputForm}
                      label="Коэффициент конверсии при списании"
                      disabled={isLoading}
                    />
                    <Field
                      name="maxTransfer"
                      component={InputForm}
                      label="Максимальная сумма списания бонусов"
                      disabled={isLoading}
                    />
                    <Field
                      name="minTransfer"
                      component={InputForm}
                      label="Минимальная сумма списания бонусов"
                      disabled={isLoading}
                    />
                  </FormSection>
                </Form>
              )}
            </Formik>
          </ContentContainerColumn>
        </ContentContainer>
      </CardContainer>
    </Container>
  )
}
